// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-button-sm[data-v-1b4e496c]{height:35px;width:35px;font-size:.875rem;padding:.7rem}.p-component[data-v-1b4e496c]:disabled,.p-disabled[data-v-1b4e496c]{opacity:.8}.p-dropdown[data-v-1b4e496c]{min-width:200px}.vue-json-pretty[data-v-1b4e496c]{font-family:monospace;background:#282c34;color:#fff;padding:15px;border-radius:8px;overflow-x:auto}", ""]);
// Exports
module.exports = exports;
